module.exports = __webpack_public_path__ + "static/media/cactus.9f1c9de4.svg";